import React from "react";
import { motion } from "framer-motion";
import teamMembers from "../data/teamMembers";

export default function TeamSection() {
    return (
        <section className="py-24 bg-gradient-to-b from-gray-50 to-white">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="text-center mb-12">
                    <h2 className="text-3xl md:text-4xl font-bold text-gray-900">Meet Our Team</h2>
                    <p className="text-lg text-gray-600">Specialists who put people first.</p>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
                    {teamMembers.map((member, index) => (
                        <motion.article
                            key={index}
                            whileHover={{ y: -4, scale: 1.02 }}
                            className="group relative overflow-hidden rounded-2xl border border-gray-200 bg-white shadow-sm"
                        >
                            <div className="absolute inset-x-0 -top-px h-1 bg-gradient-to-r from-blue-600 via-sky-400 to-cyan-400" />
                            <div className="p-6">
                                <div className="flex items-center gap-4">
                                    <img src={member.image} alt={member.name} className="h-16 w-16 rounded-full object-cover ring-2 ring-blue-100" />
                                    <div>
                                        <h3 className="text-lg font-bold text-gray-900">{member.name}</h3>
                                        <p className="text-blue-700 font-medium">{member.position}</p>
                                    </div>
                                </div>
                                <p className="mt-4 text-sm text-gray-600">{member.description}</p>
                            </div>
                        </motion.article>
                    ))}
                </div>
            </div>
        </section>
    );
}